import React from "react";
import "./RoleCards.css";
import { FaUserGraduate, FaBriefcase, FaLightbulb, FaHome } from "react-icons/fa";

const RoleCards = () => {
  const roles = [
    {
      icon: <FaUserGraduate />,
      title: "Are you a student?",
      desc: <><b>Speak English confidently</b> – in classrooms, debates and general campus life</>
    },
    {
      icon: <FaBriefcase />,
      title: "Are you a professional?",
      desc: <><b>Build your career</b> – achieve success in interviews, office presentations and client meetings</>
    },
    {
      icon: <FaLightbulb />,
      title: "Are you an entrepreneur?",
      desc: "Be bold in client meetings, networking and building global opportunities"
    },
    {
      icon: <FaHome />,
      title: "Are you a home maker?",
      desc: "Participate in conversations confidently – from parent-teacher meetings to helping your children with homework and making new friends in society"
    }
  ];

  return (
    <div className="rolecards-container">
      {roles.map((role, index) => (
        <div key={index} className="rolecard">
          <div className="role-icon">{role.icon}</div>
          <h3>{role.title}</h3>
          <p>{role.desc}</p>
        </div>
      ))}
    </div>
  );
};

export default RoleCards;
